// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"9244f81f","106":"aadd7224","295":"197d330c","477":"a9f2f9db","825":"13b03183"}[chunkId] + ".chunk.css";
};